import {
  Directive,
  ElementRef,
  forwardRef,
  HostListener,
  Renderer2,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

type FormControlValue = string | number | boolean;

@Directive({
  selector: '[digicemFormControl]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormControlDirective),
      multi: true,
    },
  ],
})
export class FormControlDirective implements ControlValueAccessor {
  constructor(
    private element: ElementRef,
    private renderer: Renderer2,
  ) {
    this.onChange = () => {};
  }

  private onChange: (value: FormControlValue) => void;

  writeValue(value: FormControlValue): void {
    this.renderer.setProperty(this.element.nativeElement, 'value', value);
  }

  registerOnChange(fn: (value: FormControlValue) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(): void {}

  @HostListener('inputed', ['$event'])
  protected handleInputedChange(event: Event): void {
    this.onChange((event as CustomEvent<FormControlValue>).detail);
  }

  @HostListener('changed', ['$event'])
  protected handleChangedChange(event: Event): void {
    this.onChange((event as CustomEvent<FormControlValue>).detail);
  }

  @HostListener('keyUped', ['$event'])
  protected handleKeyUpedChange(event: Event): void {
    this.onChange((event as CustomEvent<FormControlValue>).detail);
  }

  @HostListener('keyDowned', ['$event'])
  protected handleKeyDownedChange(event: Event): void {
    this.onChange((event as CustomEvent<FormControlValue>).detail);
  }

  @HostListener('keyPressed', ['$event'])
  protected handleKeyPressedChange(event: Event): void {
    this.onChange((event as CustomEvent<FormControlValue>).detail);
  }

  @HostListener('blured', ['$event'])
  protected handleBluredChange(event: Event): void {
    this.onChange((event as CustomEvent<FormControlValue>).detail);
  }
}
